import { useEffect, useRef } from 'react';
import clsx from 'clsx';
import Alert from 'components/Alert';
import LazySvg from 'components/LazySvg';
import { ToastAlertSliceType } from 'services/toast-alert/types';
import TOAST_IMG_MAP from './data';
import styles from './index.module.scss';

type ToastAlertType = ToastAlertSliceType & {
  afterClose: () => void;
  isGlobal?: boolean;
  autoHide?: boolean;
  duration?: number;
  qaSelector?: string;
};

const ALERT_DURATION = 6000;

function ToastAlert({
  message,
  status,
  icon,
  afterClose,
  isGlobal = false,
  autoHide = true,
  duration = ALERT_DURATION,
  qaSelector,
}: ToastAlertType) {
  const closeIconRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    if (autoHide && message) {
      timeoutId = setTimeout(() => {
        closeIconRef.current?.click();
      }, duration);
    }

    return () => clearTimeout(timeoutId);
  }, [message, autoHide]);

  if (!message) {
    return null;
  }

  const iconName = icon ?? TOAST_IMG_MAP[status];
  const alertClassName = clsx({
    br0: isGlobal,
  });
  /* const closeIconWrapper = clsx({
    hide: autoHide,
  }); */
  const handleResetToastAlert = () => {
    afterClose();
  };

  return (
    <div className={styles.toastAlertContainer}>
      <Alert
        className={alertClassName}
        message={message}
        type={status}
        icon={<LazySvg name={iconName} />}
        showIcon
        closable={{
          'aria-label': 'close',
          closeIcon: (
            <span ref={closeIconRef} className='hide'>
              <LazySvg className={styles.closeIcon} name='close' />
            </span>
          ),
        }}
        afterClose={handleResetToastAlert}
        data-qa-selector={qaSelector}
      />
    </div>
  );
}

export default ToastAlert;
